module.exports = __webpack_public_path__ + "img/empty-flight-schedule-v2.51f13b9a.svg";